import { FC, useMemo } from "react";
import isString from "lodash/isString";

import styles from "./AssistantSearchSharePieChartTool.module.scss";
import { PieChartWithLabels } from "src/components";
import { renderPieChartLabel } from "src/features/Widgets/Components/SearchShare/utils";

// inner imports
import { SearchSharePieChartTool } from "./types";
import { formatSearchSharePieChartData } from "./utils";

type Props = Record<string, unknown>;

export const AssistantSearchSharePieChartTool: FC<Props> = ({ result }) => {
  const { dateTo, dateFrom, data } = useMemo<SearchSharePieChartTool>(() => {
    if (!isString(result)) return { dateFrom: "", dateTo: "", data: [] };

    return JSON.parse(result) || { dateFrom: "", dateTo: "", data: [] };
  }, [result]);

  const formattedTrackers = useMemo<Pick<Tracker.Data, "id" | "name">[]>(
    () =>
      data.map(({ topicId, topicName }) => ({ id: topicId, name: topicName })),
    [data],
  );

  const formattedPieChart = useMemo<Widgets.PieChart.Item>(
    () => formatSearchSharePieChartData(data, dateFrom, dateTo),
    [data, dateFrom, dateTo],
  );

  if (!data.length) return null;

  return (
    <div className={styles.wrapper}>
      <PieChartWithLabels
        data={formattedPieChart}
        trackers={formattedTrackers}
        renderLabel={renderPieChartLabel}
        valueFormatter={(value) => `${value}%`}
      />
    </div>
  );
};
